module.exports = __webpack_public_path__ + "img/idea2_p.0a332a6a.svg";